import { render } from "./IconUserFilled.vue?vue&type=template&id=4dedfb45"
import script from "./IconUserFilled.vue?vue&type=script&lang=js"
export * from "./IconUserFilled.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__